import React, { useState } from 'react';
import {
  Create,
  TextInput,
  SimpleForm,
  required,
  ReferenceInput,
  SelectInput,
  Toolbar,
  FormDataConsumer,
  useDataProvider,
  useNotify,
  SaveButton,
  useSaveContext,
} from "react-admin";
import { PERMISSIONS } from '../../constants';
import Permission from '../../components/Permission';
import { getChainId } from '../../lib';
import { CPFInput } from '../../components/Inputs';
import { useFormContext, useFormState } from 'react-hook-form';
import AttendantWithConflictDialog from './AttendantWithConflictDialog';
import { applySaveErrors } from '../../components/SaveConfirmButton/applySaveErrors';

const SaveConfirmButton = ({ formData, ...props }) => {

  const { isSubmitting } = useFormState();

  const saveContext = useSaveContext();
  const form = useFormContext();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [isLoading, setIsLoading] = useState(false);
  const [showConflictDialog, setShowConflictDialog] = useState(false);
  const [attendantsWithConflicts, setAttendantsWithConflicts] = useState<Array<any>>([]);

  const handleSaveButton = async (formData: any) => {
    setIsLoading(true);
    //@ts-ignore
    dataProvider.getList('attendants', { filter: { identfids: [formData.identfid] }, pagination: { perPage: null, page: 1 } })
      .then(({ data }) => {
        if (data.length) {
          setShowConflictDialog(true);
          setAttendantsWithConflicts(data);
        } else {
          handleSubmit();
        }
      })
      .catch(() => {
        notify('Não foi possível verificar a disponibilidade do Identfid');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const handleSubmit = async () => {
    setShowConflictDialog(false);
    setIsLoading(true);
    const errors = saveContext.save && await saveContext.save(formData);
    setIsLoading(false);
    applySaveErrors(errors, form.setError, notify);
  }

  const handleCancel = () => {
    setShowConflictDialog(false);
  }

  return (
    <>
      <SaveButton disabled={isLoading || isSubmitting} onClick={form.handleSubmit(handleSaveButton)} />
      <AttendantWithConflictDialog
        isVisible={showConflictDialog}
        attendants={attendantsWithConflicts}
        handleClose={handleCancel}
        handleConfirm={handleSubmit}
      />
    </>
  );
}

const AttendantCreate = (props) => {

  const ToolbarCustom = () => {
    return (
      <Toolbar>
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            return <SaveConfirmButton
              {...rest}
              formData={formData}
            />
          }}
        </FormDataConsumer>
      </Toolbar>
    );
  }

  return (
    <Permission permission={PERMISSIONS.CREATE_ATTENDANT}>
      <Create title='Adicionar frentista' {...props} mutationMode="pessimistic">
        <SimpleForm defaultValues={{ chainId: getChainId() }} toolbar={<ToolbarCustom />} sx={{ maxWidth: 600 }}>
          <TextInput source="name" label="Nome" validate={required("Nome é obrigatório")} sx={{ minWidth: 300 }} />
          <TextInput source="identfid" label="Identificador" validate={required("Identificador é obrigatório")} sx={{ minWidth: 300 }} />
          <Permission permission={PERMISSIONS.ADMIN}>
            <ReferenceInput label="Rede" source="chainId" reference="chains">
              <SelectInput optionText="name" sx={{ minWidth: 300 }} />
            </ReferenceInput>
          </Permission>
          <CPFInput source="cpf" label="CPF" isRequired sx={{ minWidth: 300 }} />
        </SimpleForm>
      </Create>
    </Permission>
  );
}

export default AttendantCreate;